import { handleActions } from 'redux-actions';
import { editWish, updateEdits, clearEditWish } from './actions';

const defaultState = {
  editedWishId: undefined,
  edits: {}
};

export default handleActions({
  [editWish]: (state, { payload }) => {
    const newState = { ...state, editedWishId: payload };
    newState.edits[payload] = {};
    return newState;
  },
  [updateEdits]: (state, { payload: { wishId, edits } }) => {
    const newState = { ...state };
    newState.edits[wishId] = { ...newState.edits[wishId], ...edits };
    return newState;
  },
  [clearEditWish]: (state, { payload }) => {
    const editedWishId = state.editedWishId === payload ? undefined : state.editedWishId;
    const newState = { ...state, editedWishId };
    delete newState.edits[payload];
    return newState;
  },
}, defaultState);



// WEBPACK FOOTER //
// ./src/store/editWish/reducer.js